<template>
  <div class="">
    <!-- <div class="absolute h-full lg:hidden md:hidden block top-0 left-0 w-full">
      <img
        src="../../../assets/images/line/cg-line-1.svg"
        alt="bg"
        class="h-full w-full sm-h400px"
      />
    </div> -->
    <!-- <div class="absolute bg-design4 mob-hidden">
      <img
        src="../../../assets/images/bg-des/bgd4.svg"
        alt="bg-polygon"
        class=""
      />
    </div>
    <div class="absolute bg-design-cs mob-hidden">
      <img
        src="../../../assets/images/Ellipse 12.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="absolute bg-design-cs2 mob-hidden">
      <img
        src="../../../assets/images/Ellipse 12.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div> -->
    <p
      class="title md-fsize25 sm-fsize16 md:font-normal lg:font-normal font-bold lg:mt-0 md:mt-0 mt-8"
    >
      Case Studies
    </p>
    <div class="lg:flex md:flex lg:gap-10 md:gap-10 items-center">
      <div class="lg:w-1/2 md:w-1/2 h-full flex items-center">
        <div class="">
          <img
            src="https://nimbuscluster.blob.core.windows.net/server01/caregiversaathi/CG/Caregiver-Page/case-study.jpg"
            alt=""
            class="m-auto custborderradius"
          />
        </div>
      </div>
      <div class="md:w-1/2 lg:w-1/2 w-full">
        <div class="">
          <p class="subtitle lg:pt-0 md:pt-0 pt-2 lh32px sm-fsize13 sm-lh22">
            <i class="fsize15px">
              “People have texted me... that [Caregiver Saathi's] mantras that I
              share on WhatsApp help them. I feel so happy that something that
              has helped me is helping someone else too”
            </i>
          </p>
          <p
            class="subtitle md-fsize18 lg:pt-8 md:pt-8 lg:pt- 4 md:pt-4 pt-2 lh32px sm-fsize13 sm-lh26"
          >
            When Gayathri's father was ill, she became his primary caregiver
            along with her mother. Never having realized what caregiver burnout
            is, she and her mother were battling with it. After a friend pointed
            it out, Gayathri did some research. She came across an effective
            solution of being part of a support group.
          </p>
          <p class="subtitle md-fsize18 pt-8 lh32px mob-hidden">
            She discusses about the importance of support groups, what caregiver
            mantras are and how it helped her. Finally, she talks about the
            community that supported her during the difficult times in the
            lockdown.
          </p>
        </div>
        <div class="md:pt-10 lg:pt-10 pt-6">
          <a
            href="https://caregiversaathi.co.in/insights/blogsPage/624d2da1420273444089cd65"
          >
            <base-button
              outline
              type="primary"
              class="md:px-10 lg:px-10 px-6 md:py-3 lg:py-3 py-1 fs16700 border-2"
              >Read More</base-button
            >
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import casestudyMixin from "@/mixins/casestudy";

export default {
  mixins: [casestudyMixin],
  methods: {
    handleClick() {
      this.$router.push({ name: "insights-blogs" });
      // this.openCaseStudy("Case Study: The Healing Power of Acceptance");
    },
  },
};
</script>
